<form [formGroup]="form" class="form-group gw-relative">
  <ng-container *ngIf="!isLoading; else skeleton" class="gw-p-small">
    <label
      *ngIf="label"
      [attr.for]="id"
      class="gw-form-label"
      [ngClass]="{required: required}"
    >
      {{ label | translate }}

      <gatewee-icon
        *ngIf="info"
        icon="@tui.info"
        iconStyle="primary"
        size="14px"
        class="gw-text-text-action"
      ></gatewee-icon>
    </label>

    <div class="gw-input-group">
      <div
        *ngIf="iconName"
        class="gw-w-[44px] gw-h-[42px] gw-bg-background-elevation-2 gw-flex gw-items-center gw-justify-center gw-border-border-normal gw-border gw-border-solid gw-rounded-tl-[10px] gw-rounded-bl-[10px]"
        aria-hidden="true"
      >
        <gatewee-icon [icon]="iconName" size="16px"></gatewee-icon>
      </div>

      <ng-container [ngSwitch]="type">
        <input
          *ngSwitchCase="'currency'"
          type="text"
          class="gw-input-base"
          [class.switch-input]="switch"
          [id]="id"
          [formControl]="control"
          [placeholder]="placeholder"
          mask="separator.2"
          thousandSeparator="."
          decimalMarker=","
          [ngClass]="inputClasses"
          [readonly]="readonly"
          (blur)="onBlur($event)"
        />

        <input
          *ngSwitchCase="'number'"
          type="number"
          class="gw-input-base"
          [id]="id"
          [class.less-icon]="!iconName"
          [formControl]="control"
          [placeholder]="placeholder"
          [max]="max"
          [min]="min"
          [ngClass]="inputClasses"
          [readonly]="readonly"
          (blur)="onBlur($event)"
        />

        <input
          *ngSwitchCase="'rate'"
          type="text"
          class="gw-input-base"
          [id]="id"
          [formControl]="control"
          [placeholder]="placeholder"
          mask="separator.2"
          thousandSeparator="."
          inputmode="decimal"
          maxlength="5"
          [ngClass]="inputClasses"
          [readonly]="readonly"
          (blur)="onBlur($event)"
        />

        <input
          *ngSwitchDefault
          class="gw-input-base"
          [class.less-icon]="!iconName"
          [type]="type || 'text'"
          [id]="id"
          [formControl]="control"
          [placeholder]="placeholder"
          [mask]="mask"
          [attr.maxlength]="max"
          [ngClass]="inputClasses"
          [readonly]="readonly"
          (blur)="onBlur($event)"
        />
      </ng-container>

      <div
        *ngIf="type === 'currency' && switch"
        class="gw-bg-background-elevation-2 gw-h-[44px] gw-flex gw-items-center gw-justify-center gw-px-[12px] gw-border gw-border-solid gw-border-border-normal gw-rounded-br-[12px] gw-rounded-tr-[12px]"
      >
        <div
          (click)="toggleCurrency()"
          class="gw-bg-[#2B7FFF] gw-relative gw-w-[48px] gw-h-[24px] gw-rounded-full gw-flex gw-items-center gw-px-[3px] gw-cursor-pointer gw-transition-all gw-duration-300 gw-overflow-hidden"
        >
          <div
            [class.gw-translate-x-[24px]]="isCurrency"
            class="gw-w-[18px] gw-h-[18px] gw-rounded-full gw-bg-white gw-shadow gw-flex gw-items-center gw-justify-center gw-transition-all gw-duration-300"
          >
            <ng-container [ngSwitch]="isCurrency">
              <gatewee-icon
                *ngSwitchCase="true"
                class="gw-text-[#2B7FFF] gw-text-[12px]"
                icon="@tui.circle-dollar-sign"
                size="16px"
              ></gatewee-icon>
              <gatewee-icon
                *ngSwitchDefault
                icon="@tui.percent"
                iconStyle="primary"
                size="12px"
                class="gw-text-[#2B7FFF]"
              ></gatewee-icon>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <small
      *ngIf="hint"
      class="text-muted form-hint"
      [class.mt-2]="control.invalid && control.touched"
    >
      <i [class]="hint.icon"></i>
      {{ hint.message | translate }}
    </small>
  </ng-container>

  <ng-template #skeleton>
    <gatewee-skeleton></gatewee-skeleton>
  </ng-template>

  <error-message
    *ngIf="control"
    [control]="control"
    [customMessages]="customMessages"
  ></error-message>
</form>
